/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_IngestInputs */

const es_tools_legajox_ingest = /** @type {(inputs: Tools_Legajox_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestando desde Legajox...`)
};

const en_tools_legajox_ingest = /** @type {(inputs: Tools_Legajox_IngestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesting from Legajox...`)
};

/**
* | output |
* | --- |
* | "Ingesting from Legajox..." |
*
* @param {Tools_Legajox_IngestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_ingest = /** @type {((inputs?: Tools_Legajox_IngestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_IngestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_ingest(inputs)
	return en_tools_legajox_ingest(inputs)
});
export { tools_legajox_ingest as "tools.legajox.ingest" }